import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { CountdownService } from 'src/app/services/countdown.service';

@Component({
  selector: 'app-countdown',
  templateUrl: './countdown.component.html',
  styleUrls: ['./countdown.component.scss'],
})
export class CountdownComponent implements OnInit {
  @Input() initialValue: number;
  formattedTime = '00:00:00';

  constructor(private countdownService: CountdownService) {}

  ngOnInit() {
    const initialValue = this.initialValue ?? 3600; // Set the initial countdown value in seconds (e.g., 1 hour, 1 minute, 6 seconds)
    this.countdownService.startCountdown(initialValue);

    this.countdownService.countdown$.subscribe(remainingTime => {
      this.formattedTime = this.formatTime(remainingTime);
    });

    setTimeout(() => {
      if (this.formattedTime === '00:00:00') {
        this.formattedTime = 'expired';
      }
    }, 1000);
  }

  private formatTime(seconds: number): string {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = seconds % 60;

    const formattedHours = this.padZero(hours);
    const formattedMinutes = this.padZero(minutes);
    const formattedSeconds = this.padZero(remainingSeconds);

    return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
  }

  private padZero(value: number): string {
    const roundedVal = Math.floor(value);
    return roundedVal < 10 ? `0${roundedVal}` : `${roundedVal}`;
  }
}
